import { risapi, getAxiosConfig, getAPIFullUrl } from './risapi';
import { convertJsonToFormData } from '../commonfunctions';

/**
 * Fetches the list of all heads of accounts for the main master page.
 * @param {object} filters - Pagination and search filters.
 * @param {function} callback - The function to call with the response.
 */
export const getHeadsOfAccounts = async (filters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/head-of-accounts', filters), getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

/**
 * Fetches ONLY the heads of accounts marked as 'expense'.
 * This is the new, dedicated function for your form dropdown.
 * @param {function} callback - The function to call with the response.
 */
export const getExpenseHeads = async (callback) => {
    try {
        // This hits a new, dedicated endpoint for efficiency.
        const response = await risapi.get('/api/expense-heads', getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

/**
 * Fetches a single head of account by its ID.
 * @param {number} id - The ID of the head of account.
 * @param {function} callback - The function to call with the response.
 */
export const fetchHeadOfAccount = async (id, callback) => {
     try {
        const response = await risapi.get(`/api/head-of-accounts/${id}`, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

/**
 * Creates a new head of account.
 * @param {object} data - The data for the new head of account.
 * @param {function} callback - The function to call with the response.
 */
export const createHeadOfAccount = async (data, callback) => {
    try {
        const formData = convertJsonToFormData(data);
        const response = await risapi.post('/api/head-of-accounts', formData, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

/**
 * Updates an existing head of account.
 * @param {object} data - The data for the head of account to update, including its ID.
 * @param {function} callback - The function to call with the response.
 */
export const updateHeadOfAccount = async (data, callback) => {
    try {
        const formData = convertJsonToFormData(data);
        formData.append('_method', 'put');
        const response = await risapi.post(`/api/head-of-accounts/${data.id}`, formData, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

/**
 * Deletes a head of account.
 * @param {object} head - The head of account object to delete.
 * @param {function} callback - The function to call with the response.
 */
export const destroyHeadOfAccount = async (head, callback) => {
    try {
        const response = await risapi.delete(`/api/head-of-accounts/${head.id}`, getAxiosConfig());
        if (response.status === 204) {
            callback({ success: true, head: head });
        }
    } catch (error) {
        callback(error);
    }
};

